var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#E5E7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 14.9609C18.1232 15.0558 19.3397 15.7207 20.1338 16.7832C20.3855 17.1203 20.3162 17.5975 19.9795 17.8496C19.6427 18.1017 19.1661 18.0332 18.9141 17.6963C18.3846 16.9879 17.5731 16.5446 16.6914 16.4814C15.8777 16.4232 15.0775 16.6944 14.4678 17.2285L14.3193 17.3672L12.0439 19.6445C10.8896 20.8408 10.9061 22.742 12.0811 23.918C13.2109 25.0487 15.0111 25.1077 16.2021 24.0918L16.3418 23.9648L17.6445 22.6611C17.942 22.3635 18.4243 22.3635 18.7217 22.6611C18.9921 22.9317 19.0161 23.3549 18.7949 23.6533L18.7217 23.7393L17.4102 25.0518C15.6171 26.7849 12.7666 26.7601 11.0039 24.9961C9.29464 23.2855 9.22014 20.5511 10.8047 18.7422L10.958 18.5762L13.2422 16.2891C14.1209 15.4094 15.3171 14.9289 16.5527 14.9502L16.8008 14.9609ZM18.5908 10.9521C20.3839 9.21903 23.2344 9.24378 24.9971 11.0078C26.706 12.7184 26.7807 15.4519 25.1963 17.2607L25.043 17.4277L22.7588 19.7148C21.8215 20.6532 20.5226 21.1377 19.2002 21.043C17.8778 20.9482 16.6614 20.2832 15.8672 19.2207C15.6153 18.8837 15.6838 18.4055 16.0205 18.1533C16.3573 17.9012 16.835 17.9705 17.0869 18.3076C17.6163 19.0159 18.4271 19.4592 19.3086 19.5225C20.1224 19.5808 20.9233 19.3095 21.5332 18.7754L21.6807 18.6367L23.957 16.3594C25.1112 15.1632 25.0946 13.2619 23.9199 12.0859C22.79 10.9552 20.9894 10.8957 19.7969 11.9131L19.6572 12.041L18.3467 13.3438C18.0484 13.6405 17.5661 13.6393 17.2695 13.3408C17.0002 13.0695 16.9773 12.6463 17.1992 12.3486L17.2734 12.2627L18.5908 10.9521Z",
    fill: "#8CAEB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobLink);
export default __webpack_public_path__ + "static/media/job-link.87883dc6e3d25786e266d033b7feba21.svg";
export { ForwardRef as ReactComponent };